// 地区格式化
export function locationFormatter(loaction = '') {
  console.log('location----', loaction);
  const [country = '', , province = ''] = loaction.split('|');
  let result = '';
  // 先判断国家，再判断省份
  switch (country) {
    // case '中国':
    //   result = 'China';
    //   break;
    case '瑞典':
      result = 'Sweden';
      break;
    case '英国':
      result = 'England';
      break;
    case '美国':
      result = 'USA';
      break;
    case '德国':
      result = 'DE';
      break;
    default:
      result = 'China';
      break;
  }
  // 如果是中国，再判断省份
  if (result === 'China') {
    if (province.startsWith('香港')) {
      result = 'HK';
    }
  }
  return result;
}
